export default function Footer() {
  return (
    <footer>
      <div className="footer-main">

        <div className="footer-left">
          <div className="footer-logo">
            <div className="footer-logo1">
              <img src="pics/bnt.png" alt="BNT Logo" />
            </div>
            <div className="footer-logo2">
              <h1>
                <span className="green">BRODKAST </span>
                <span className="white">NG </span>
                <span className="white">TALINO </span>
                <span className="green">2026 </span>
              </h1>
            </div>
          </div>

          <div className="footer-badges">
            <div className="footer-badge"><img src="pics/tup.png" alt="tup" /></div>
            <div className="footer-badge"><img src="pics/coe.png" alt="coe" /></div>
            <div className="footer-badge"><img src="pics/ece.png" alt="ece" /></div>
            <div className="footer-badge"><img src="pics/oeces.png" alt="oeces" /></div>
          </div>

          <div className="footer-address">
            Technological University of the Philippines – Manila<br />
            Organization of Electronics Engineering Students<br />
            Ayala Blvd., Ermita, Manila, 1000
          </div>
        </div>

        {/* RIGHT: Contact Info */}
        <div className="footer-right">

          <div className="footer-contact-header">
            <span className="footer-contact-title">Contact Us:</span>
            <div className="footer-socials">
              <a href="https://www.facebook.com/TUPM.BrodkastngTalino" target="_blank" rel="noreferrer" title="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.tiktok.com/@oeces_tupmnl" target="_blank" rel="noreferrer" title="TikTok">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="https://x.com/oecestupmanila" target="_blank" rel="noreferrer" title="X / Twitter">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="mailto:oeces@tup.edu.ph" target="_blank" rel="noreferrer" title="Email">
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>

          <div className="footer-contact-person">
            <strong>Alethea Coleen R. Rañosa</strong>
            <span>BNT Event Head</span>
            <span>0916 545 6990</span>
            <span>coleenranosa13@gmail.com</span>
          </div>

          <div className="footer-contact-person">
            <strong>Reynalyn Mae F. Calumpang</strong>
            <span>External Linkages – Sponsorships Head</span>
            <span>0926 691 8570</span>
            <span>calumpangreynalynmae@gmail.com</span>
          </div>

          <div className="footer-email-note">
            or email us at our official email:<br />
            <a href="mailto:oeces@tup.edu.ph">oeces@tup.edu.ph</a>
          </div>

        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        Copyright &copy; 2026 Brodkast Ng Talino<br />
        All rights reserved
      </div>
    </footer>
  );
}